import * as Types from './actionTypes';

const initialState = {
  data: [],
  isFetching: true,
  nextCursor: null,
  prevCursor: null,
  cache: {},
  cursor: null,
  isMakingProfile: false,
  toggleMakingProfile: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.MAKE_PROFILE:
      return {
        ...state,
        isMakingProfile: true,
      };
    case Types.TOGGLE_MAKING_PROFILE:
      return {
        ...state,
        toggleMakingProfile: !state.toggleMakingProfile,
      };

    case Types.MADE_PROFILE:
      return {
        ...state,
        isMakingProfile: false,
      };
    case Types.FETCH:
      return {
        ...state,
        isFetching: true,
        data: [],
      };

    case Types.FETCHING:
      return {
        ...state,
        isFetching: true,
        data: action.payload.append ? state.data : [],
      };

    case Types.FETCHED:
      return {
        ...state,
        isFetching: false,
        data: action.meta.append ? [...state.data, ...action.payload.data] : action.payload.data,
        nextCursor: action.meta.nextCursor ? action.meta.nextCursor : null,
        prevCursor: action.meta.prevCursor ? action.meta.prevCursor : null,
        cursor: action.meta.cursor,
      };

    case Types.CACHE:
      return {
        ...state,
        cache: {
          ...state.cache,
          [action.payload.key]: {
            ...(state.cache[action.payload.key] ? state.cache[action.payload.key] : {}),
            ...action.payload.payload,
          },
        },
      };
  }

  return state;
};
